"use strict";

const RoutineInspectionRouteFactory = require("./routineInspectionRouteFactory");

const OutfallRoutes = function () {
  const inspectionRoute = RoutineInspectionRouteFactory.createRoute({
    resourceKey: "outfallRoutineMaintenance",
    assetType: "outfall",
  });

  const legacyRedirectRoute = RoutineInspectionRouteFactory.createLegacyRedirect({
    assetType: "outfall",
    dataView: "muni-outfalls",
  });

  const legacyDryWeatherRedirectRoute = RoutineInspectionRouteFactory.createLegacyRedirect({
    assetType: "outfall",
    dataView: "dry-weather",
  });

  return { inspectionRoute, legacyRedirectRoute, legacyDryWeatherRedirectRoute };
};

module.exports = OutfallRoutes();
